// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3nNJB","error":"Textarea_error__3ovwI","readonly":"Textarea_readonly__2m79o","disabled":"Textarea_disabled__1fc-5"};